<template>
	<div class="personalInfo">
		<van-row style="margin-bottom:5px;">
			<van-col span="18">
				<van-field
					v-model.trim="psrInfo.surname"
					label="姓氏："
					placeholder="请输入姓氏"
					:readonly="readonly"
					:required="!readonly"
					clearable
				>
					<template #right-icon>
						<van-icon name="ellipsis" @click="showFamilyPicker=true"/>
					</template>
				</van-field>
				<van-field
					v-model.trim="psrInfo.name"
					label="名字："
					placeholder="请输入名字"
					:required="!readonly"
					clearable
				></van-field>
			</van-col>
			<van-col span="6" style="background-color:#fff;">
				<van-uploader v-if="!readonly" ref="clansLogoUploader" :style="'height:90px;'" max-count="1" v-model="imgList" :max-size="imgSizeLimit" @oversize="onOversize" :after-read="afterReadImg" :before-read="beforeRead"/>
				<img v-if="readonly&&imgList.length==1" :src="imgList[0].url" height="87px"/>
			</van-col>
		</van-row>
		<van-cell-group class="self"> 
			<van-cell
				@click="showPickers(3)"
				title="人员类型："
				is-link
				:value="psrTypeStr"
				title-class="van-cell-title"
				v-if="psrTypes.length>0"
			></van-cell>
			<van-cell
				@click="showPickers(1)"
				title="宗系："
				is-link
				:value="jishiStr"
				required
				title-class="van-cell-title"
			></van-cell>
			<van-cell
				@click="showPickers(4)"
				title="家庭排行："
				is-link
				required
				:value="orderStr"
				title-class="van-cell-title"
			></van-cell>
			<van-field
				v-model.trim="psrInfo.use_name"
				label="曾用姓名："
				placeholder="请输入曾用姓名"
				:readonly="readonly"
				clearable
			></van-field>
			<van-field
				v-model.trim="psrInfo.zihao"
				label="字号："
				placeholder="请输入字号"
				:readonly="readonly"
				clearable
			></van-field>
			<van-cell
				@click="showBirthPickers"
				title="生辰日期："
				is-link
				:value="birthdayStr"
				title-class="van-cell-title"
			></van-cell>
			<van-cell
				@click="showPickers(6)"
				title="闰月："
				is-link
				:value="shifouArr[psrInfo.leep_month]"
				title-class="van-cell-title"
				:readonly="readonly"
				v-show="showLeepMonth"
			>
			</van-cell>
			<van-field
				v-model.trim="psrInfo.birthdate"
				label=""
				placeholder="请输入生辰日期"
				v-show="showBirthDate"
				:readonly="readonly"
				clearable
			></van-field>
			<van-cell
				@click="showPickers(7)"
				title="生肖："
				is-link
				:value="psrInfo.zodiac"
				title-class="van-cell-title"
			>
			</van-cell>
			<van-field
				v-model.trim="psrInfo.telphone"
				label="联系电话："
				:placeholder="readonly?'':(psrInfo.u_id&&psrInfo.u_id!=u_id?'非本人不可修改':'请输入联系电话')"
				:readonly="(readonly||(psrInfo.u_id&&psrInfo.u_id!=u_id))?true:false"
				clearable
			>
				<template #right-icon v-if="!readonly&&psrInfo.id&&(!psrInfo.u_id ||(psrInfo.u_id==u_id&&$parent.$parent.$parent.$parent.$parent.infoAuth.infoAuth))">
					<van-icon name="user-circle-o" @click="toBindUser" class="skin_color"/>
				</template>
			</van-field>
			<van-cell
				@click="showPickers(2)"
				title="现居地区："
				is-link
				:value="psrInfo.live_area"
				title-class="van-cell-title"
			></van-cell>
			<van-field
				v-model.trim="psrInfo.live_address"
				label="街道地址："
				placeholder="请输入街道地址"
				:readonly="readonly"
				clearable
			@blur="locationAmapByAddress(psrInfo.live_address)"
			></van-field>

			<div id="amap_container_psr" class="amap_container"></div>


			<van-field
				v-model.trim="psrInfo.birth_address"
				label="祖籍地址："
				placeholder="请输入祖籍地址"
				:readonly="readonly"
				clearable
			></van-field>
			<van-field
			  v-model.trim="psrInfo.remark"
			  rows="3"
			  autosize
			  label="简介："
			  type="textarea"
			  maxlength="3000"
			  placeholder="请输入简介内容"
				:readonly="readonly"
			  show-word-limit
			/>
			<van-cell
				@click="showPickers(5)"
				title="继承过继："
				is-link
				:value="shifouArr[psrInfo.adpot_inherit]"
				title-class="van-cell-title"
			></van-cell>
			<van-field
				v-model.trim="psrInfo.id_num"
				label="身份证号："
				placeholder="请输入身份证号"
				:readonly="readonly"
				clearable
			></van-field>
			<van-cell
				:value="''"
				title-class="van-cell-title"
				v-if="psrTypes.length==0"
			>
				<template #title>
					<span class="custom-title">抱养：{{isAdoption?'是':'否'}}</span>
				</template>
				<template #right-icon v-if="!readonly">
					<van-switch v-model="isAdoption"  @input="onAdoptionChk"/>
				</template>
			</van-cell>
			<van-cell
				:value="''"
				title-class="van-cell-title"
			>
				<template #title>
					<span class="custom-title">健在：{{inliveChk?'是':'否'}}</span>
				</template>
				<template #right-icon v-if="!readonly">
					<van-switch v-model="inliveChk"  @input="onInliveChk"/>
				</template>
				<template #label v-if="!readonly">
					{{inliveChk?'':'请在【过往信息】中填写'}}
				</template>
			</van-cell>

			<van-button type="primary" block  @click="savePersonalInfo()" v-if="!readonly">保存</van-button>
		</van-cell-group>



		<van-popup v-model="showPicker" position="bottom">
		  <van-picker
			show-toolbar
			title="请选择"
			:columns="pickerColumns"
			@cancel="showPicker = false"
			@confirm="onConfirmPicker"
		  />
		</van-popup>

		<van-popup v-model="showFamilyPicker" position="right" :style="{ 'width': '200px','height':'80%' }" get-container=".personalInfo">
			<van-index-bar v-if="families.length" :index-list="firstPin">
				<span v-for="(fm, ind) in families" :key="ind">
					<van-index-anchor :index="fm.char"/>
					<van-cell :title="n" v-for="(n, ind2) in fm.data" :key="ind+'_'+ind2" @click="selFamilyName(n)"/>
				</span>
			</van-index-bar>
		</van-popup>

		<van-popup v-model="showBirthPicker" position="bottom">
			<van-picker show-toolbar :columns="birthColumns" 
				@change="onChangeBirthPicker" 
				@cancel="showBirthPicker = false"
				@confirm="onConfirmBirthPicker"
			/>
		</van-popup>

	</div>
</template>

<script>

import { Col, Row, IndexBar, IndexAnchor, Switch  } from 'vant';
import { FirstPin,chkImgType,num2chinese,leftPadStr } from "@/utils/common.js";
import {lunarUtil} from "@/utils/lunar.js";

export default {
	name: "personalInfo",
	components: {
		"van-row":Row,
		"van-col":Col,
		"van-index-bar":IndexBar,
		"van-index-anchor":IndexAnchor,
		"van-switch":Switch 
	},
	props:{
		info:Object,
		relation:Object,
		families:Array,
		scsx:Object,
		pasted:Boolean,
		readonly:Boolean
	},
	computed:{
		zongxiArrs:function(){
			let zxArr = ['始祖'];
			for(var i=2;i<101;i++){
				zxArr.push('第'+num2chinese(i)+'世')
			}
			return zxArr;
		},
		orderArrs:function(){
			let xdArr = ['未知','长子','次子'];
			for(var i=3;i<101;i++){
				xdArr.push(num2chinese(i)+'子')
			}
			let jmArr = ['未知','长女','次女'];
			for(var i=3;i<101;i++){
				jmArr.push(num2chinese(i)+'女')
			}
			return {'M':xdArr,'F':jmArr};
		},
		scsxCols:function(){
			let sc = [];
			let sx = [];
			let cols = [];
			let obj = null;
			for(var k in this.scsx){
				obj = this.scsx[k];
				sc.push(obj.sc);
				sx.push(obj.sx);
				obj['key'] = k;
				cols.push(obj);
			}
			return {sc:sc, sx:sx, cols:cols}
		},
		birthColumn:function(){
			let lMonths = ['正月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'];
			let lMonthDays = ['初一','初二','初三','初四','初五','初六','初七','初八','初九','初十','十一','十二','十三','十四','十五','十六','十七','十八','十九','廿','廿一','廿二','廿三','廿四','廿五','廿六','廿七','廿八','廿九','三十'];
			

			let sMonths = ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'];
			let sMonthDays = ['1日','2日','3日','4日','5日','6日','7日','8日','9日','10日','11日','12日','13日','14日','15日','16日','17日','18日','19日','20日','21日','22日','23日','24日','25日','26日','27日','28日','29日','30日','31日'];
			
			let years = [];
			let curyear = new Date().getFullYear();
			for(var i=0;i<curyear;i++){
				years.push(leftPadStr(i+1,4,'0')+'年');
			}
			return {
				cur: curyear,
				years: years,
				yin:{m:lMonths,d:lMonthDays},
				yang:{m:sMonths,d:sMonthDays}
			};
		}
	},
	data() {
		return {
			firstPin:FirstPin,
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id")+"token"),
			areaColumns:JSON.parse(localStorage.getItem("area_districts")),
			attach_url:this.Conf.serverPre,
			amap:{},
			amapGeocoder:{},
			amapMarker:false,
			showPicker:false,
			showPickerType:0,
			pickerColumns:[],

			lunarObj:null,

			psrInfo:{},
			saveFlag:false,
			preLiveAddress:'',

			jishiStr:'请选择',
			psrTypes:[],
			psrTypeStr:'',

			orderStr:'',
			shifouArr:['否','是'],

			showFamilyPicker:false,
			imgList:[],
			imgSizeLimit:500 * 1024,

			showBirthPicker:false,
			birthColumns:[{values:['阴历','阳历','手动输入']},{values:[]},{values:[]},{values:[]},{values:[]}],
			clendarType:'阴历',
			showBirthDate:false,
			birthdayStr:'请选择',

			showLeepMonth:false,
			inliveChk:true,
			isAdoption:false
		};
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		showPickers(t){
			if(this.readonly) return false;
			this.showPickerType = t;
			if(t ==1){
				this.pickerColumns = this.zongxiArrs;
			}
			if(t ==2){
				this.pickerColumns = this.areaColumns;
			}
			if(t ==3){
				this.pickerColumns = this.psrTypes;
			}
			if(t ==4){
				this.pickerColumns = this.orderArrs[this.psrInfo.sex];
			}
			if(t ==5 || t ==6){
				this.pickerColumns = this.shifouArr;
			}
			if(t==7){
				this.pickerColumns = this.scsxCols.sx;
			}
			this.showPicker = true;
		},
		showBirthPickers(){
			if(this.readonly) return false;
			this.showBirthPicker=!this.showBirthPicker
		},
		onConfirmPicker(value, indexs){
			if(this.showPickerType==1){
				this.jishiStr = value;
				this.psrInfo.jishi = parseInt(indexs)+1;
			}
			if(this.showPickerType==2){
				this.onAreaConfirm(value, indexs);
			}
			if(this.showPickerType==3){
				this.psrTypeStr = value[0];
				this.psrInfo.types = parseInt(indexs)+1;
			}
			if(this.showPickerType==4){
				this.orderStr = value;
				this.psrInfo.orders = indexs;
			}
			if(this.showPickerType==5){
				this.psrInfo.adpot_inherit = indexs;
			}
			if(this.showPickerType==6){
				this.psrInfo.leep_month = indexs;
			}
			if(this.showPickerType==7){
				this.psrInfo.zodiac = value;
			}
			this.showPicker = false;
		},
		onAreaConfirm(value, indexs) {
			this.psrInfo['live_area'] = value.join("")
			this.initAmapByCity(value.join(""))
		},
		initAmapByCity(cityad){
			this.amapGeocoder = new AMap.Geocoder({
				city:''//cityad
			});
			this.locationAmapByAddress(cityad)
		},
		markerAmap(lnglat,reset){
			if(this.amapMarker){
				this.amap.remove(this.amapMarker);
			}
			this.amapMarker = new AMap.Marker();
			this.amapMarker.setPosition(lnglat);
			this.amap.add(this.amapMarker);
			this.amap.setFitView(this.amapMarker);
			this.psrInfo['lnglat'] = lnglat[0] + ',' + lnglat[1];
			if(reset){
				this.resetAddressByLnglat(lnglat);
			}
		},
		resetAddressByLnglat(lnglat){
			var geocoder = new AMap.Geocoder({
				city: ''
			})
			let that = this;
			geocoder.getAddress(lnglat, function (status, data) {
				if (status === 'complete' && data.info === 'OK') {
					// result为对应的地理位置详细信息
					//console.log(data)
					let faddress = data.regeocode.formattedAddress;
					let acomp = data.regeocode.addressComponent;
					let district = acomp.district;
					if(!(that.psrInfo.live_area && that.psrInfo.live_area.indexOf(district) > -1)){
						that.psrInfo.live_area = acomp.province+acomp.city+district;
					}
					let fadr = faddress.split(district);
					that.$delete(fadr, 0);
					that.psrInfo.live_address = fadr.join(district);
					that.$forceUpdate();
				}
			})

		},
		locationAmapByAddress(ads){
			if(ads && ads != this.preLiveAddress){
				let that = this;
				this.amapGeocoder.getLocation(ads, function(status, result) {
					if (status === 'complete'&&result.geocodes.length) {
						let local = result.geocodes[0].location;
						that.markerAmap([local.lng, local.lat],0);
					}else{
						that.$toast.fail("地址定位失败，请手动指定");
					}
				});
			}
		},
		beforeRead(file){
			return chkImgType(file);
		},
		onOversize(){
			this.$toast.fail("图片大小不能超过 500kb");
		},
		afterReadImg(file){
			this.psrInfo['new_head_img'] = file.content
			this.imgList = [{url:file.content, isImage: true}];
		},
		selFamilyName(n){
			this.psrInfo.surname = n;
			this.showFamilyPicker = false;
		},
		setPersonalTypeOptions(t){
			this.psrTypes = [{values:['入赘','夫婿'],defaultIndex:1}];
			this.psrTypeStr = this.psrTypes[0].values[t-1];
		},
		onChangeBirthPicker(picker, values) {
			if(values[0] == this.clendarType) return false;
			this.clendarType = values[0];
			if(values[0]=='手动输入'){
				picker.setColumnValues(1, []);
				picker.setColumnValues(2, []);
				picker.setColumnValues(3, []);
				picker.setColumnValues(4, []);
			}else {
				let years = [];
				let curyear = new Date().getFullYear();
				for(var i=0;i<curyear;i++){
					years.push(leftPadStr(i+1, 4, '0')+'年');
				}
				picker.setColumnValues(1, this.birthColumn.years);
				picker.setColumnIndex(1,this.birthColumn.cur-1)
				if(values[0] == '阴历'){
					picker.setColumnValues(2,this.birthColumn.yin.m);
					picker.setColumnValues(3,this.birthColumn.yin.d);
					picker.setColumnValues(4,this.scsxCols.sc);
				}else{
					picker.setColumnValues(2,this.birthColumn.yang.m);
					picker.setColumnValues(3,this.birthColumn.yang.d);
					picker.setColumnValues(4,this.scsxCols.sc);
				}
			}
		},
		onConfirmBirthPicker(vals, inds){
			this.birthdayStr = vals.join('')
			if(inds[0]==2){
				this.showBirthDate = true;
				this.showLeepMonth = false;
				this.psrInfo.birthday = null;
				this.psrInfo.calendar = null;
				this.psrInfo.leep_month = 0;
				this.psrInfo.hours = null;

			}else{
				this.showLeepMonth = true;
				this.showBirthDate = false;
				this.psrInfo.birthdate = null;

				this.psrInfo.birthday = leftPadStr((inds[1]+1), 4, '0')+'-'+leftPadStr((inds[2]+1), 2,'0')+'-'+leftPadStr((inds[3]+1), 2,'0')+' '+this.scsxCols.cols[inds[4]].sj+':00';
				this.psrInfo.calendar = inds[0]==1?'S':'L';
				this.psrInfo.hours = this.scsxCols.cols[inds[4]].key;
				
				if((inds[1]+1) >= 1900){
					this.psrInfo.zodiac = this.scsxCols.sx[(((inds[1]+1) - 1900) % 12 + 12) % 12];
					if(inds[0]==0 && this.lunarObj.lunar_leap_m(inds[1]+1) == (inds[2]+1)){
						this.psrInfo.leep_month = 1;
					}
				}
			}
			this.showBirthPicker = false;
		},
		showDefaultHeadImg(img, sex){
			if(img){
				this.imgList = [{url:img.indexOf('http')==-1?(this.attach_url+img):img, isImage: true}];
			}else{
				this.imgList = [{url:require("../../assets/img/clans/"+sex+".png"), isImage: true}];
			}
		},
		loadPersonalInfo(id){
			var params = {
				u_id: this.u_id,
				token: this.token,
				id: this.psrInfo.id
			};
			var url = this.Conf.serverUrl + "clans/personalInfo?num="+Math.random();
			let that = this;
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				if(response.data.info){
					that.psrInfo = response.data.info;
					that.preLiveAddress = that.psrInfo['live_address'];
					that.psrInfo['pre_types'] = that.psrInfo['types'];
					that.psrInfo['pre_in_laws'] = that.psrInfo['in_laws'];
					if(that.psrInfo.types > 0){
						that.setPersonalTypeOptions(that.psrInfo.types);
					}
					
					this.isAdoption = that.psrInfo.types==-1;

					that.showDefaultHeadImg(that.psrInfo.head_img, that.psrInfo.sex);
					if(that.psrInfo.lnglat){
						that.markerAmap(that.psrInfo.lnglat.split(","),0);
					}
					if(that.psrInfo.jishi){
						that.jishiStr = that.zongxiArrs[that.psrInfo.jishi-1]
					}
					if(that.psrInfo.orders){
						that.orderStr = that.orderArrs[that.psrInfo.sex][that.psrInfo.orders]
					}
					if(that.psrInfo.leep_month){
						that.showLeepMonth = true;
					}
					if(that.psrInfo.birthdate){
						that.birthColumns[0].defaultIndex = 2;
						that.showBirthDate = true;
						that.birthdayStr = '其他';
						that.birthColumns[1] = [];
						that.birthColumns[2] = [];
						that.birthColumns[3] = [];
						that.birthColumns[4] = [];
					}else{
						that.showBirthDate = false;
						that.birthColumns[0].defaultIndex = that.psrInfo.calendar=="S"?1:0;
						if(that.psrInfo.birthday){
							that.birthdayStr = that.psrInfo.calendar=="S"?'阳历':'阴历';
							let birthdays = that.psrInfo.birthday.split(' ')[0].split('-');

							if(birthdays[0] >= 1900){
								that.psrInfo.zodiac = that.scsxCols.sx[((birthdays[0] - 1900) % 12 + 12) % 12];
							}

							that.birthdayStr += birthdays[0]+'年'; 
							that.birthColumns[1].defaultIndex = birthdays[0]-1;
							that.birthdayStr += birthdays[1]+'月'; 
							that.birthColumns[2].defaultIndex = birthdays[1]-1;
							that.birthdayStr += birthdays[2]+'日'; 
							that.birthColumns[3].defaultIndex = birthdays[2]-1;
							that.birthdayStr += this.scsx[that.psrInfo.hours].sc;
							that.birthColumns[4].defaultIndex = this.scsx[that.psrInfo.hours].order;
						}
					}
				}

			})
			.catch(error => {});
		},
		savePersonalInfo(){
			if(this.saveFlag){
				this.$toast.fail("请求尚未响应，请勿重复提交！");
				return false;
			}
			if(!this.psrInfo['surname']){
				this.$toast.fail("请输入/选择姓氏！");
				return false;
			}
			if(!this.psrInfo['name']){
				this.$toast.fail("请输入名字！");
				return false;
			}
			if(this.jishiStr == '请选择'){
				this.$toast.fail("请选择宗系！");
				return false;
			}
			if(this.orderStr == ''){
				this.$toast.fail("请选择家庭排行！");
				return false;
			}
			if(this.u_id && this.token){
				//this.psrInfo['data_u_id'] = this.u_id;
				if(this.imgList.length > 0 && this.imgList[0].content){
					this.psrInfo['new_head_img'] = this.imgList[0].content;
				}
				var params = {
					u_id:this.u_id,
					token:this.token,
					info:this.psrInfo,
					relation:this.relation
				};
				this.saveFlag = true;
				let that = this;
				var url = this.Conf.serverUrl + "clans/savePersonal" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					this.saveFlag = false;
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.$emit("callAfterSave", response.data.data);
						if(!that.psrInfo.id){
							that.psrInfo.id = response.data.data.info.id;
							that.psrInfo.data_u_id = that.u_id;
						}
					}
				})
				.catch(error => {});
			}else{
				this.$toast.fail("请先登录！");
			}
		},
		init(){
			this.psrInfo = this.info;

			this.getStateConfigs();
			this.isAdoption = false;
			if(this.psrInfo.id){
				this.loadPersonalInfo(this.psrInfo.id);
			}else{
				if(this.relation.relationShip==3){
					this.setPersonalTypeOptions(2);
				}else{
					this.psrInfo.types = 0;
					this.psrInfo.leep_month = 0;
					this.psrInfo.adpot_inherit = 0;
				}
				this.showDefaultHeadImg(null, this.psrInfo.sex);
				if(this.psrInfo.jishi){
					this.jishiStr = this.zongxiArrs[this.psrInfo.jishi-1]
				}
			}
			this.birthColumns[1].values = this.birthColumn.years;
			this.birthColumns[1].defaultIndex = this.birthColumn.cur-1;
			this.birthColumns[2].values = this.birthColumn.yin.m;
			this.birthColumns[3].values = this.birthColumn.yin.d;
			this.birthColumns[4].values = this.scsxCols.sc;
		},
		onInliveChk(chk){
			this.$emit('update:pasted',chk?false:true);
		},
		onAdoptionChk(chk){
			this.psrInfo.types = chk?-1:0;
		},
		toBindUser(){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "即将"+(this.psrInfo.u_id?"解绑":"绑定")+"人员与账号关系，确定？",
			})
			.then(() => {
				var params = {
					u_id:this.u_id,
					token:this.token,
					id:this.psrInfo.id
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/bindPersonal" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if(response.data.code == 200){
						if(response.data.data.rst){
							that.psrInfo.u_id = response.data.data.types?that.u_id:0;
							that.$toast.success(response.data.data.types?'绑定成功！':'解绑失败！');
						}else{
							that.$toast.success(response.data.data.types?'绑定失败，请重试！':'解绑失败，请重试！');
						}
						return false;
					}
					if(response.data.msg){
						that.$toast.fail(response.data.msg);
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		}
	},
	created() {
		this.inliveChk = this.pasted?false:true;

		let that = this;
		this.$nextTick(() => {
			that.lunarObj = new lunarUtil();

			that.amap = new AMap.Map("amap_container_psr", {
				resizeEnable: true
			});
			if(!that.readonly){
				that.amap.on('click', function(e) {
					that.markerAmap([e.lnglat.getLng(), e.lnglat.getLat()],1);
				});
			}
			
			that.init();
		});

	},
	watch:{
	}
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Clans/PersonalInfo.vue